import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, errMsg, TOKEN_KEY } from "../lib/api";
import { PW_HINT, pwValid } from "../pages/PasswordReset";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { PasswordInput } from "./ui/password-input";
import { Label } from "./ui/label";

export const ChangePasswordButton = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const submit = async (e) => {
    e.preventDefault();
    if (!pwValid(f.next)) return toast.error(PW_HINT);
    if (f.next !== f.confirm) return toast.error("Konfirmasi password tidak sama");
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      localStorage.setItem(TOKEN_KEY, data.token);
      toast.success("Password berhasil diganti. Sesi di perangkat lain otomatis keluar.");
      setOpen(false);
      setF({ current: "", next: "", confirm: "" });
    } catch (e2) {
      toast.error(errMsg(e2));
    }
  };
  const field = (k, l) => (
    <div className="space-y-1.5"><Label>{l}</Label><PasswordInput required value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`change-pw-${k}-input`} /></div>
  );
  return (
    <>
      <button onClick={() => setOpen(true)} className="w-full flex items-center gap-2 text-xs text-muted-foreground hover:text-foreground px-3 py-1" data-testid="change-password-btn">
        <KeyRound className="h-3.5 w-3.5" />Ganti Password
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="change-password-dialog">
          <DialogHeader><DialogTitle className="font-display">Ganti Password</DialogTitle><DialogDescription>{PW_HINT}</DialogDescription></DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            {field("current", "Password Saat Ini")}
            {field("next", "Password Baru")}
            {field("confirm", "Ulangi Password Baru")}
            <Button type="submit" className="w-full" data-testid="change-pw-submit-btn">Simpan</Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
